import { Alert, type AlertTone } from "./alert";
import { cn } from "./cn";

export type ToastEntry = {
  id: string;
  tone: AlertTone;
  message: string;
  // Marks the exit transition; the provider removes the entry once it ends.
  leaving: boolean;
};

// Fixed overlay strip for transient action feedback — full-width above the
// bottom edge on mobile, bottom-right column from `sm:`. Being position:fixed,
// toasts never push document content around (the whole point: no CLS).
//
// NOTE: a <dialog> opened via showModal() lives in the browser top layer and
// renders ABOVE this strip regardless of z-index. Close the modal before (or
// synchronously with) firing a toast — all current call sites do.
export function ToastViewport({
  toasts,
  onDismiss,
}: {
  toasts: ToastEntry[];
  onDismiss: (id: string) => void;
}) {
  // Render nothing when idle — no toasts on first paint.
  if (toasts.length === 0) return null;
  return (
    <div class="pointer-events-none fixed inset-x-0 bottom-0 z-50 flex flex-col gap-2 px-4 pb-4 sm:inset-x-auto sm:right-4 sm:bottom-4 sm:w-96 sm:px-0 sm:pb-0">
      {toasts.map((t) => (
        <div
          key={t.id}
          class={cn(
            "pointer-events-auto transition duration-200 motion-safe:animate-toast-in",
            t.leaving && "translate-y-2 opacity-0",
          )}
        >
          <Alert tone={t.tone} class="shadow-sm" onClose={() => onDismiss(t.id)}>
            {t.message}
          </Alert>
        </div>
      ))}
    </div>
  );
}
